import { useNavigate } from "react-router-dom";
import { observer } from "mobx-react-lite";
import { useStore } from "../../app/stores/store";
import AtdIntegrationSettings from "./AtdIntegrationSettings";
import { useEditorStatuses } from "./editorStatus";
import KlaviyoIntegrationSettings from "./KlaviyoIntegrationSettings";
import SettingsPageLayout from "./SettingsPageLayout";
import Turn14IntegrationSettings from "./Turn14IntegrationSettings";
import { showsVendorIntegrations } from "./vendorIntegrationAccess";

const editors = ["klaviyo"] as const;

function IntegrationsSettingsPage() {
    const navigate = useNavigate();
    const { userStore } = useStore();
    const { report, form } = useEditorStatuses(editors);
    return (
        <SettingsPageLayout form={form}>
            <KlaviyoIntegrationSettings onStatusChange={report.klaviyo} />
            {showsVendorIntegrations(userStore?.user?.shopDomain) && <>
                <Turn14IntegrationSettings onOpenFitmentDataSources={() => navigate("/settings/data")} />
                <AtdIntegrationSettings />
            </>}
        </SettingsPageLayout>
    );
}

export default observer(IntegrationsSettingsPage);
